import { render, staticRenderFns } from "./ProcessManage.vue?vue&type=template&id=7130ff58&scoped=true&"
import script from "./ProcessManage.vue?vue&type=script&lang=js&"
export * from "./ProcessManage.vue?vue&type=script&lang=js&"
import style0 from "./ProcessManage.vue?vue&type=style&index=0&id=7130ff58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130ff58",
  null
  
)

export default component.exports